import React from "react";
import "./QuickLinks.css";
import { useGlobalDialog } from "../../../contexts/GlobalDialogContext";
import AdmissionCriteriaModal from "../../../components/modalComponents/admissionCriteriaModal/AdmissionCriteriaModal";
import AcademicsModal from "../../../components/modalComponents/academicsModal/AcademicsModal";

const QuickLinks = ({ contactUsRef }) => {
  const { openDialog } = useGlobalDialog();

  // Scroll to the footer when the "Contact Us" button is clicked
  const handleContactUsClick = () => {
    setTimeout(() => {
      if (contactUsRef.current) {
        contactUsRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end", // Scroll to the end of the footer
        });
      }
    }, 0); // Use a timeout to wait for any pending layout reflows
  };

  const handleAdmissionCriteriaClick = () => {
    openDialog(AdmissionCriteriaModal, "Admission Criteria");
  };

  const handleAcademicsClick = () => {
    openDialog(AcademicsModal, "Academics");
  };

  return (
    <section className="quicklinks-container">
      <div className="button-array">
        <button
          className="quicklink admission-button"
          onClick={handleAdmissionCriteriaClick}
        >
          <h3 className="button-content">Admission Criteria</h3>
        </button>

        <button
          className="quicklink facilities-button"
          onClick={handleAcademicsClick}
        >
          <h3 className="button-content">Academics</h3>
        </button>

        <button
          className="quicklink facilities-button"
          onClick={handleContactUsClick}
        >
          <h3 className="button-content">Contact Us</h3>
        </button>

        {/* <button className="quicklink facilities-button">
          <h3 className="button-content">Amenities</h3>
        </button> */}
      </div>
    </section>
  );
};

export default QuickLinks;
